// Task types and workflows carry a Phosphor icon name (docs/03); the console offers this short
// list and draws any other name with a neutral glyph.
import {
  Article,
  Browser,
  Bug,
  ChatCircleText,
  Cloud,
  Code,
  Database,
  FlowArrow,
  GitPullRequest,
  type Icon,
  Layout,
  MagnifyingGlass,
  Robot,
  Rocket,
  ShieldCheck,
  TestTube,
  Wrench,
} from "@phosphor-icons/react";

export const ICONS: Record<string, Icon> = {
  code: Code,
  layout: Layout,
  article: Article,
  cloud: Cloud,
  database: Database,
  browser: Browser,
  bug: Bug,
  "chat-circle-text": ChatCircleText,
  "flow-arrow": FlowArrow,
  "git-pull-request": GitPullRequest,
  "magnifying-glass": MagnifyingGlass,
  robot: Robot,
  rocket: Rocket,
  "shield-check": ShieldCheck,
  "test-tube": TestTube,
  wrench: Wrench,
};

/** The icon choices, "None" first; icon names stay as they are. */
export function iconOptions(none: string): { value: string; label: string }[] {
  return [{ value: "", label: none }, ...Object.keys(ICONS).map((name) => ({ value: name, label: name }))];
}
